import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { RouterOutlet } from '@angular/router';
import { UserDropdownComponent } from '@app/components/user-dropdown/user-dropdown.component';
import { TourAnchorMatMenuDirective } from 'ngx-ui-tour-md-menu';

@Component({
  selector: 'app-topbar',
  standalone: true,
  imports: [
    RouterOutlet,
    MatToolbarModule,
    MatIconModule,
    UserDropdownComponent,
    MatButtonModule,
    TourAnchorMatMenuDirective,
  ],
  templateUrl: './topbar.component.html',
  styleUrl: './topbar.component.scss',
})
export class TopbarComponent {}
